import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { TagCell } from "@/modules/work/jobs/timesheet/tags/_cell";
import TagFilters from "./filters";

export default function Tags() {
    const columns = [
        {
            id: "label",
            header: "Label",
            accessorKey: "label",
            sortable: true,
        },
        {
            id: "color",
            header: "Preview",
            cell: ({ row }) => <TagCell getValue={() => row.original} />,
        },
        {
            id: "for",
            header: "For",
            accessorKey: "for",
            sortable: true,
            cell: ({ getValue }) => (
                <span className="capitalize">{getValue()}</span>
            ),
        },
    ];

    const fields = ["id", "label", "for", "color"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="tags"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Tags</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Tags"
                    endPoint="tags"
                    columns={columns}
                    renderFilters={TagFilters}
                    meta={{
                        fields,
                    }}
                    sortBy="label"
                    sortOrder="aesc"
                    href={(item) => item.id}
                />
            </div>
        </div>
    );
}
